module.exports = __webpack_public_path__ + "img/2023HAPPY.1cb23de7.jpg";